import React from 'react';
import { Progress, extendTheme, ChakraProvider, Box, Text } from '@chakra-ui/react';
const customTheme = extendTheme({
    components: {
        Progress: {
            baseStyle: {
                filledTrack: {
                    bg: '#5612F8',
                },
            },
        },
    },
});

const MyProgressBar = ({ left, value }) => {
    return (
        <ChakraProvider theme={customTheme}>
            <Box pos='relative'>
                <Progress value={value} height='20px' bg='#CBD5E0'>
                    <Text
                        fontSize='10px'
                        fontWeight='600'
                        lineHeight='12px'
                        letterSpacing='0em'
                        position='absolute'
                        top='55%'
                        left={`${left}%`}
                        transform='translate(-50%, -50%)'
                        color='white'
                    >
                        {value}%
                    </Text>
                </Progress>
            </Box>
        </ChakraProvider>
    );
};

export default MyProgressBar;
